var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39496 16.0873V16.7502C4.39496 17.9269 5.3489 18.8809 6.52564 18.8809H16.2498C17.4266 18.8809 18.3805 17.9269 18.3805 16.7502V7.04372C18.3805 5.86698 17.4266 4.91303 16.2498 4.91303H15.6047M1.61914 13.9566V4.25018C1.61914 3.0734 2.57308 2.1195 3.74982 2.1195H13.474C14.6508 2.1195 15.6047 3.0734 15.6047 4.25018V13.9566C15.6047 15.1333 14.6508 16.0873 13.474 16.0873H3.74982C2.57308 16.0873 1.61914 15.1333 1.61914 13.9566Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCopy;